module.exports = __webpack_public_path__ + "pc/img/about_solution02.5b8cd6f2.jpg";